<template>
  <div class="titleout">
      <div class="titlebox f-row-b">
        <div class="title f-row-1">
            <span class="wl-icon f-row-b">
                <span></span>
                <span></span>
            </span>
            {{ nav&&nav.length > 0?nav[nav.length-1].label:''}}
        </div>
        <div class="nav_name" v-if="!isSearch">
          当前位置：
          <span class="pinter" v-for="(item, index) in nav" :key="index" @click="navFun(item,index)">
            {{ index == nav.length - 1 ? item.label : item.label + ">" }}
          </span>
        </div>
        <div class="nav_name" v-else>
          <input type="text" ref='inpt' class="ipt" v-model="keyword" @blur="search"/>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    isSearch:{
      type:Boolean
    },
    nav: {
      type: Array || String,
    },
  },
  data() {
    return {
      keyword:''
    };
  },
  created(){
    document.onkeydown=e=>{ 
      var _key=window.event.keyCode;
      if(_key==13){ 
        this.$refs.inpt.blur()
      }
    }
  },
  mounted(){
    if(this.nav && this.nav[0]){
      this.setHeadActIndex(this.nav[0].path)
    }
  },
  methods: {
    setHeadActIndex(path){
      var index=0
      if (path == '/Organization') {
          index = 1
      }
      if (path == '/workNews') {
          index = 2
      }
      if (path == '/partyService') {
          index = 3
      }
      if (path == '/focusYouth') {
          index = 4
      }
      if (path == '/Rights') {
          index = 5
      }
      if (path == '/youthVolunteer') {
          index = 6
      }
      if (path == '/fileInfo') {
          index = 7
      }
      if (path == '/doctor') {
          index = 8
      }
      localStorage.setItem('titBoxSetIndex',index)
    },
    search(){
      console.log(this.keyword)
      this.$emit('onSearch', this.keyword);
      this.$nextTick(()=>{
        // this.keyword=''
      });
    },
    navFun(e,index) {
      var dataVal = {};
      if (e.type) {
        dataVal.type = e.type;
      }
      if (e.id) {
        dataVal.id = e.id;
      }
      if(index+1==this.nav.length){
        return
      }
      this.$router.push({ path: e.path, query: dataVal });
    },
  },
};
</script>

<style scoped lang="scss">
.wl-icon{
    display: inline-block;
    width: 40px;
    text-align: center;
     transform:skew(30deg);
    -webkit-transform:skew(30deg);
    -moz-transform:skew(30deg);
    span{
        display: inline-block;
        width: 5px;
        height:20px;
        background: #A62725;
        margin-right:5px;
    }
}
.titlebox {
  width: calc(100% - 100px);
  margin-left: 50px;
  padding: 61px 0px 27px;
//   height: 80px;
//   line-height: 80px;
  border-bottom: 3px solid #A62725;
  
  .title {
    font-size: 30px;
    font-weight: bold;
    overflow: hidden;
  }
  .nav_name {
    color: #A62725;
    font-size: 14px;
    .ipt {
      width: 255px;
      height: 31px;
      border: 1px solid #eeeeee;
      background-size: 17px 17px;
    }
  }
}
</style>
